var _circle, _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRecurringRed = function SvgRecurringRed(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FFF3F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 5.99984C8.68613 5.99984 5.99984 8.68613 5.99984 11.9998C5.99984 15.3135 8.68613 17.9998 11.9998 17.9998C15.3135 17.9998 17.9998 15.3135 17.9998 11.9998C17.9998 11.6316 18.2983 11.3332 18.6665 11.3332C19.0347 11.3332 19.3332 11.6316 19.3332 11.9998C19.3332 16.0499 16.0499 19.3332 11.9998 19.3332C7.94975 19.3332 4.6665 16.0499 4.6665 11.9998C4.6665 7.94975 7.94975 4.6665 11.9998 4.6665C14.5598 4.6665 16.8129 5.97873 18.1237 7.96412C18.3266 8.27138 18.2419 8.68492 17.9347 8.88778C17.6274 9.09064 17.2139 9.00601 17.011 8.69875C15.9365 7.07126 14.0931 5.99984 11.9998 5.99984Z",
    fill: "#DE3121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4.6665C18.3682 4.6665 18.6667 4.96498 18.6667 5.33317V8.6665C18.6667 9.03469 18.3682 9.33317 18 9.33317H14.6667C14.2985 9.33317 14 9.03469 14 8.6665C14 8.29831 14.2985 7.99984 14.6667 7.99984H17.3333V5.33317C17.3333 4.96498 17.6318 4.6665 18 4.6665Z",
    fill: "#DE3121"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecurringRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recurring-red.dfb74e1d.svg";
export { ForwardRef as ReactComponent };